<style lang="scss" scoped>
.youtube-content-list {
  padding-top: 2rem;
  padding-left: 2rem;
  padding-right: 2rem;

  li {
    margin-bottom: 2rem;
  }

  .thumbnail-image {

  }

  .thumbnail-title {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1.4rem;
    font-weight: bold;
  }
}
</style>

<template>
  <main class="main" role="main">
    <div class="main__inner bg"><!-- 배경: bg-->
      <div class="main__con p64">
        <ul class="youtube-content-list">
          <li v-for="(customerCase, index) in customerCaseList" :key="index">
            <div class="thumbnail-image">
              <iframe style="width: 100%; height: 100%; border: 0;" :src="`https://www.youtube.com/embed/${customerCase.youtubeURL}`"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="thumbnail-title">{{ customerCase.caseTitle }}</div>
            <div class="line"></div>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      customerCaseList: [],
    }
  },
  created: function () {
    this.getCustomerCase()
  },
  methods: {
    getCustomerCase: async function () {
      const res = await this.$MainSvc.getCustomerCase()
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.customerCaseList = entity
      }

    }
  }
}
</script>
